// extracted by mini-css-extract-plugin
export default {"loading_page":"styles_loading_page__ysdWU"};